<template>
  <v-container>
    <v-breadcrumbs class="pa-2">
       <v-breadcrumbs-item to="/" router>
            <u class="subtitle-1">Dashboard</u>
        </v-breadcrumbs-item>
        <v-icon class="px-2 subtitle-1">mdi-chevron-right</v-icon>
      <v-breadcrumbs-item class="title">Tablet List</v-breadcrumbs-item>
    </v-breadcrumbs>
    
    <v-card class="pl-5 pr-5 pb-5" style="display:inline-block; width:950px" v-resize="resizeBodySection">
      <v-row no-gutters class="text-center" :style="`height: ${bodySectionHeight+36}px;`">
        <v-col class="mb-5" cols="12">
          <v-row>
            <v-col cols=2 style="margin-left:15px">Name</v-col>
            <v-col cols=1 style="margin-left:0px">Farm</v-col>
            <v-col cols=4 style="margin-left:10px">Last Sync</v-col>
            <v-col cols=2 style="margin-left:-35px">DB (GiB)</v-col>
            <v-col cols=2 style="margin-left:-65px">Conflict?</v-col>
            <v-col cols=1></v-col>
          </v-row>
          <v-card class="overflow-y-auto pa-0" :style="`border: ${tableBorderColor} solid 5px; background-color:tablet-list-background; height: ${bodySectionHeight-8}px;`">
            <v-simple-table justify="center" >
              <tr v-for="(next, i) in tabletInfo" :key="i">
                <td class="py-3">
                  <v-card style="margin-top:0px;" class="pt-1 ml-2 pb-1 rounded-0">
                    <router-link :key="i" :to="{name: 'TabletDetail', query: {name: next.name}}">{{ next.name }}</router-link>
                  </v-card>
                </td>
                <td>
                  {{ next.farmCode }}
                </td>
                <td>
                  <v-chip style="height:34px; border-width:4px" outlined medium :color="colorSyncCells(next.lastSync)"> {{ next.lastSync }}</v-chip>
                </td>
                <td>
                    <v-progress-circular
                      style="margin-top:-3px; font-size:12px;"
                      :rotate="180"
                      :size="42"
                      :width="5"
                      :value="next.dbSize*10"
                      :color="styleDatabaseSize(next.dbSize)">
                      {{ next.dbSize }}
                    </v-progress-circular>
                </td>
                <td>
                  <div style="text-align:left; padding-bottom: 4px; padding-left:20px; margin-top:2px">
                    <v-icon v-if="next.hasConflicts" :color="styleConflict(next.hasConflicts)">mdi-close-circle-outline</v-icon>
                    <v-icon v-else :color="styleConflict(next.hasConflicts)">mdi-check-circle-outline</v-icon> 
                    {{ next.hasConflicts?'Yes': 'No' }}
                  </div>
                </td>
                <td>
                  <v-btn>Sync</v-btn>
                </td>
            </tr>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: 'TabletList',
    data: () => ({ 
      tableBorderColor: 'red',
      bodySectionHeight: 0
    }),
    async created() {
        this.tableBorderColor = this.$vuetify.theme.themes['dark'].themeColorB;
    },
    computed: {
      ...mapState(["tabletInfo"]),
    },
    methods: {
      colorSyncCells(lastSync) {
        var currentDate = new Date();
        var cellDate = new Date(lastSync);
              
        if (cellDate.getTime() > (currentDate.getTime() - ( 24*60*60*1000)) )
          return "success";
        else if (cellDate.getTime() <= (currentDate.getTime() - (24 * 60 * 60 * 1000)) && 
                 cellDate.getTime() > (currentDate.getTime() - (48 * 60 * 60 * 1000)) ) 
          return "warning";
        else 
          return "error";
      },

      styleDatabaseSize(size) {
         if (size < 8) 
          return "success";
        else if (size >= 8 && size < 9) 
          return "warning";
        else 
          return "error";
      },

      styleConflict(hasConflict) {
        if (hasConflict) return "error";
        else return "success";
      },

      resizeBodySection() {
        this.bodySectionHeight = window.innerHeight-210;
      }
    }
  }
</script>